import React, { useContext, useEffect} from 'react'; 
import cl from './List.module.css'
import { AppContext } from "../../../../providers/appProvider"
import ErrorModal from '../../../UI/ErrorModal/ErrorModal';
import Pagination from '../../../UI/Pagination/Pagination'; 
import Add from '../Add/Add'; 
import Delete from '../Delete/Delete'; 
import tbl from '../../../../assets/Style/Table.module.css'
import { useParser } from '../../../../hooks/useParser';


const formatDate = (dateString) => {
  if (!dateString) {  
      return "";
  } 
  const atDate = new Date(dateString);
  if (isNaN(atDate.getTime())) {
      return "";  
  } 

  // Add 4 hours to the date
  atDate.setHours(atDate.getHours() - 4);

  const months = [
      "იან", "თებ", "მარ", "აპრ", "მაი", "ივნ",
      "ივლ", "აგვ", "სექ", "ოქტ", "ნოე", "დეკ"
  ]; 
  const day = atDate.getDate();
  const month = months[atDate.getMonth()]; 
  const year = atDate.getFullYear();
  const hours = atDate.getHours().toString().padStart(2, '0');
  const minutes = atDate.getMinutes().toString().padStart(2, '0');
  
  return `${day} ${month} ${year}, ${hours}:${minutes}`;
};



const ParserList = () => {
  const { parserService } = useParser(50);
  const {appState, app} = useContext(AppContext);

  useEffect( ()=> {
    parserService.fetchList()
  }, [])


 
 

  return <div>

    <div className={ cl.headMain }> 
        <h1>პარსერი</h1>   
     </div>

     <Add parserService={parserService} /> 
 
    <div className={tbl.table + ' ' + cl.table} style={{ maxHeight: 'calc(100vh - 215px)' }}>

      <table>
          <thead>
              <tr>
              <th className={cl.id}>#</th>
              <th>სელერი</th>
              <th>საიტი</th>
              <th>მარკა</th>
              <th>მოდელი</th>
              <th>წელი</th>
              <th>გაშვება</th>  
              <th>შექმნა</th>  
              <th>აიტვირთა</th>  
              <th>ლიმიტი</th>  
              <th>სულ</th>  
              <th>სტატუსი</th>  
              <th> </th> 
              </tr>
          </thead>
          <tbody>
              {parserService.items.map((item) =>
                  <tr key={item.id} >
                  <td className={cl.id} >{item.id}</td>
                  <td>{item.saler_id} {item.saler?.id}</td> 
                  <td>{item.website_id}</td> 
                  <td>{item.maker_id}</td> 
                  <td>{item.model_id}</td> 
                  <td>{item.year_from } - {item.year_to}</td> 
                  <td>{formatDate(item.start_at)}   </td> 
                  <td>{formatDate(item.created_at)}</td> 
                  <td>{item.uploaded}</td> 
                  <td>{item.limit}</td> 
                  <td>{item.total}</td> 
                  <td>
                  <span
                      style={{
                          color: item.status === 1 ? "#ff7500" : item.status === 2 ? "#1254e7" : item.status === 3 ? "green" : "black"
                      }}
                  >
                      {item.status === 1 ? "მოლოდინში" : item.status === 2 ? "მუშავდება" : item.status === 3 ? "დასრულებული" : ""}
                  </span>
 
                  </td> 
                  <td className={ cl.btntbl }>
                      <div className={ cl.btns }> 

                        <Delete parserService={parserService} defaultAgent={item}/> 
                      </div>
                  </td>
                  </tr>  
              )}
          </tbody>
      </table>

    </div>

  
   {appState.error && <ErrorModal message={appState.error} onClose={() => app.clearError(false)} />}

    <Pagination total={parserService.total} 
                perPage={parserService.filter.limit} 
                current={parserService.filter.page} 
                paginate={(page) => {
                  parserService.setFilter({
                    ...parserService.filter,
                    page: page,
                  });
                }}
                setLimit={(limit) => {
                  parserService.setFilter({
                    ...parserService.filter,
                    limit: limit,
                  });
                }}
                />
  </div>;
}

export default ParserList;